<template>

    <GuideLayout :title="title">

        <div class="flex justify-center font-nexa text-blue text-3xl text-center leading normal">
            {{ __('Notifications') }}
        </div>


        <div class="font-nexa text-center text-black text-opacity-60 text-xl mt-4 leading-normal">
            {{
                __('We recommend that you activate browser notifications, to receive your training reminders')
            }}
        </div>


        <button class=" px-6 py-5 mx-auto my-5 rounded-xl text-white text-xl font-bold"
            :class="{
                'bg-green-600': ! onesignal_is_subscribed,
                'bg-blue': onesignal_is_subscribed
            }"
            style="letter-spacing: 1px;"
            @click="! onesignal_is_subscribed ? onesignal_handle_click() : false">

            {{ __( onesignal_subscribe_button_text ) }}

        </button>


        <img src="/images/allow-browser-notifications.png"
            style="max-width: 400px;margin-bottom: 8.9rem;"
            class="w-full mb-auto"
        />


        <div class="mx-auto flex flex-col justify-start items-center xl:flex-row xl:justify-center xl:items-start">

            <Button class="mt-10 bg-blue bg-opacity-0 border border-gray-400 text-2xl text-black pl-12 pr-12 pt-5 pb-4 xl:mr-10 hover:opacity-40 hover:text-white"
                    @click="handle_click_previous">

                {{ __('Previous') }}

            </Button>

            <Button class="mt-10 mb-10 text-2xl pl-12 pr-12 pt-5 pb-4"
                    @click="handle_click_next">

                {{ __('Next') }}

            </Button>

        </div>

    </GuideLayout>

</template>

<script>
import {defineComponent} from "vue";
import GuideLayout from "@/Layouts/GuideLayout";
import Logo from "@/Components/Logo";
import Button from "@/Components/Button";
import Link from "@/Components/Button";

export default defineComponent({

    name: "StartupGuideNotifications",


    components: {
        Logo,
        GuideLayout,
        Button,
        Link
    },


    props: {
        categories: {
            type: Array
        },
    },



    computed: {

        title() {

            return this.__('Startup Guide, Notifications');

        },

    },


    methods: {

        handle_click_next() {

            this.$inertia.visit(
                this.route('startup_guide_update_user_information')
            );

        },


        handle_click_previous() {

            this.$inertia.visit(
                this.route('startup_guide_choose_categories')
            );

        },
    }

});
</script>
